import React from 'react';

export const Input = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  maxLength,
  error,
  className = '',
  showCharCount = false,
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      />
      {showCharCount && maxLength && (
        <p className="text-sm text-gray-500 mt-1 text-right">
          {value.length}/{maxLength}
        </p>
      )}
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
};
